// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__FMra+","formGroup":"LoginForm_formGroup__V5mBw"};